import * as exElement from '../element';

import type { HighlightConfig, HighlightTarget } from './types';

import { getConfig, getMatchData, isExcludedElement, isHighlightWrapper } from './utils';

// ----------------------------------------------------------------------------

function add(element: HighlightTarget, find: string, config: HighlightConfig = {}): number {
    const defConfig = getConfig(config);

    if (!find.length) {
        return 0;
    }

    if (isExcludedElement(element, defConfig)) {
        return 0;
    }

    if (element.nodeType === Node.TEXT_NODE) {
        const value = element.textContent ?? '';
        const match = getMatchData(value, find, defConfig);

        if (!match || !element.parentNode) {
            return 0;
        }

        const textNode = element as Text;
        const middleBit = textNode.splitText(match.index);
        const endBit = middleBit.splitText(match.text.length);
        const middleClone = middleBit.cloneNode(true);
        const parentNode = middleBit.parentNode;

        if (!parentNode) {
            return 0;
        }

        const elSpanHighlight = exElement.create({
            merge: defConfig,
            tag: defConfig.tag,
            class: {
                new: defConfig.className,
            },
        });

        elSpanHighlight.appendChild(middleClone);
        parentNode.replaceChild(elSpanHighlight, middleBit);

        if (typeof defConfig.fnCallback === 'function') {
            defConfig.fnCallback(elSpanHighlight);
        }

        return 1 + add(endBit, find, defConfig);
    }

    if (element.nodeType === Node.ELEMENT_NODE) {
        const elementNode = element as HTMLElement;

        if (/(script|style)/i.test(elementNode.tagName) || isHighlightWrapper(elementNode, defConfig)) {
            return 0;
        }

        let count = 0;

        for (const childNode of elementNode.childNodes) {
            count += add(childNode, find, defConfig);
        }

        return count;
    }

    return 0;
}

// ----------------------------------------------------------------------------

export { add };
